import { api } from '@/lib/api'

export interface CounselorResource {
  id: string
  title: string
  description?: string
  content: string
  isPublished: boolean
  order: number
  lastModifiedBy: string
  createdAt: string
  updatedAt: string
}

export interface ResourceListResponse {
  resources: CounselorResource[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface ResourceQueryParams {
  page?: number
  limit?: number
  search?: string
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

export class CounselorResourceService {
  /**
   * Get list of published counselor resources
   */
  static async getPublishedResources(params: ResourceQueryParams = {}): Promise<ResourceListResponse> {
    const queryParams = new URLSearchParams()

    if (params.page) queryParams.append('page', params.page.toString())
    if (params.limit) queryParams.append('limit', params.limit.toString())
    if (params.search) queryParams.append('search', params.search)
    if (params.sortBy) queryParams.append('sortBy', params.sortBy)
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder)

    const query = queryParams.toString()
    const endpoint = query ? `/counselor-resources?${query}` : '/counselor-resources'

    return await api.get<ResourceListResponse>(endpoint)
  }

  /**
   * Get a specific published counselor resource by ID
   */
  static async getPublishedResource(id: string): Promise<CounselorResource> {
    return await api.get<CounselorResource>(`/counselor-resources/${id}`)
  }
}